import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { SkillIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';

import { IDrawer } from '../../../PublicationContent';
import './styled';
import {
  DataTypeSkillIconContainer,
  DataTypeSkillPillText,
  DataTypeSkillPillWrapper,
} from './styled';

export const dataTypeSkillContentModifier = (
  node: HTMLDivElement,
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>
) => {
  node.querySelectorAll('[data-type="skills"], [data-type="skill"]').forEach((skill) => {
    const slug = skill.getAttribute('data-slug');
    const name = skill.textContent;
    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(<DataTypeSkillPill name={name || ''} />);

    template.firstChild.addEventListener('click', () => {
      setDrawer({ show: true, slug, type: 'skills' });
    });

    skill.replaceWith(template.firstChild);
  });
};

interface DataTypeSkillPillProps {
  name: string;
}

export const DataTypeSkillPill = ({ name }: DataTypeSkillPillProps) => {
  return (
    <DataTypeSkillPillWrapper>
      <DataTypeSkillIconContainer>
        <SkillIcon width={16} height={16} fill={'var(--color-data-skill-foreground)'} />
      </DataTypeSkillIconContainer>
      <DataTypeSkillPillText>{name}</DataTypeSkillPillText>
    </DataTypeSkillPillWrapper>
  );
};
